import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'grid-ui-badge',
  styleUrls: ['./badge.component.scss'],
  template: `{{ text() }}`,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'Badge',
  },
})
export class BadgeComponent {
  public readonly text = input.required<string>();
}
